import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-whiteboard',
  standalone: true,
  templateUrl: '../../assets/whiteboard.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamWhiteboardIcon {}
